/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { postSensitiveWordQuickCheck } from "../../funcs/postSensitiveWordQuickCheck.js";
import { PostSensitiveWordQuickCheckRequest$zodSchema } from "../../models/postsensitivewordquickcheckop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostSensitiveWordQuickCheckRequest$zodSchema,
};

export const tool$postSensitiveWordQuickCheck: ToolDefinition<typeof args> = {
  name: "text-post-sensitive-word-quick-check",
  description: `敏感词检测（快速）

在你的社区或应用中，需要来过滤掉不和谐的声音吗？这个接口可以助你一臂之力。

## 功能概述

我们对敏感词检测接口进行了大幅升级，现在采用高效的 **Aho-Corasick 算法**，实现了多模式字符串匹配。这意味着你不再需要手动编写复杂的正则表达式，系统会自动高效地检测出文本中的所有敏感词。

### 主要特性

- **高性能算法**：基于 Aho-Corasick 算法，单次扫描即可检测多个敏感词模式
- **简繁体支持**：自动识别和处理简体中文、繁体中文内容
- **多模匹配**：无需编写正则表达式，系统内置智能匹配逻辑
- **快速响应**：相比传统方法，检测速度显著提升

无论是论坛、社交平台还是评论系统，这个接口都能帮你快速构建内容审核功能。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await postSensitiveWordQuickCheck(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
